import loadable from "@loadable/component";
import React from "react";
import useStaticContext from "@hooks/useStaticContext";

import HeaderHome from "../Shared/HeaderHome";
import Background from "../Shared/Background";
import Footer from "../Shared/Footer";

import SchemaOrg from "@components/Global/Custom/SchemaOrg";

import CityBanner from "./CityBanner";
import CityBreadcrumbs from "./CityBreadcrumbs";
import CityCombos from "./CityCombos";

import schema from "./@data/schema.org";
import HeaderSearchBar from "@components/Main/Shared/HeaderSearchBar";

const City = () => {
	const { city, state, popularServices } = useStaticContext();

	return (
		<React.Fragment>
			<HeaderSearchBar />
			<CityBreadcrumbs city={city} state={state} />
			{/*<CityBanner city={city}/>*/}
			<CityCombos city={city} popularServices={popularServices} />
			<SchemaOrg schema={schema(city)} />
			<Footer />
		</React.Fragment>
	);
};

export default City;

export const loader = (route) =>
	loadable(() => import("./City.component"), { ssr: !!route.ssr });
